import { Component, AfterViewInit, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
// import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { UsuarioService } from 'src/app/services/usuarios.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { environment } from 'src/environments/environment';
import { alertaConfirmacion } from '../utils';
import { ToastrService } from 'ngx-toastr';
import { MdPanelControlUsuarioComponent } from '../modals/md-panel-control-usuario/md-panel-control-usuario.component';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  notificaciones: any[] = [];
  // public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;
  customerData: any = {};
  public sessionInfo: any = null;
  production
  constructor(
    private spinnerService: SpinnerService,
    private router: Router,
    private storageService: StorageService,
    private usuarioActivo: UsuarioService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private notificacionService: NotificacionesService

  ) {

    this.production = environment.production
    this.customerData = JSON.parse(this.storageService.getData('authData'))
  }


  ngOnInit() {
    this.sessionInfo = JSON.parse(StorageService.getSession())
  }

  salirSesion() {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.sessionInfo != null) {
      this.spinnerService.activarLoading(true);
      this.usuarioActivo.logout(this.sessionInfo.coduser).subscribe((res: any) => {
        this.spinnerService.activarLoading(false);
        console.log(res);
        StorageService.clearStorage();
        this.router.navigateByUrl('/login');
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        // basicAlert(err.error, 'warning', 'Aceptar');


      })
    }

  }
  salirSesion_2() {

    this.sessionInfo = JSON.parse(StorageService.getSession());
    alertaConfirmacion('¿Está seguro de salir del sistema?', 'warning', false, true).then((responseAlert) => {
      if (responseAlert) {
        this.sessionInfo = JSON.parse(StorageService.getSession());
        if (this.sessionInfo != null) {
          StorageService.clearStorage();
          this.router.navigateByUrl('/login');

          this.spinnerService.activarLoading(true);
          this.usuarioActivo.logout_v2(this.sessionInfo.id_cia, this.sessionInfo.coduser, this.sessionInfo.idSesion).subscribe((res: any) => {
            this.spinnerService.activarLoading(false);
            console.log(res);
            this.toastr.show('Se completó el proceso....');
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err);
          })
        }
      }
    })

  }

  openModal() {

  }

  openModalPanelControlUsuario() {
    const referenciaModal = this.modalService.open(MdPanelControlUsuarioComponent, { scrollable: true, backdrop: 'static', windowClass: 'md-panel-control' });
    referenciaModal.result.then((data) => {
      console.log(" data devuelta");
      console.log(data);
    }, (reason) => {
      console.log(reason);
    });
  }

}
